import type {
  TpPaymentMethodBankUI,
  TpPaymentMethodCardUI,
  TpPaymentMethodIdentifierPixUI,
  TpPaymentMethodUI,
} from '../types';
import { TpPaymentMethodType } from '../types';

export function isCardPaymentMethod(
  pm: TpPaymentMethodUI | undefined,
): pm is TpPaymentMethodCardUI {
  return pm?.type === TpPaymentMethodType.Card;
}

export function isBankPaymentMethod(
  pm: TpPaymentMethodUI | undefined,
): pm is TpPaymentMethodBankUI {
  const bankTypes = [
    TpPaymentMethodType.BankTransfer,
    TpPaymentMethodType.BankAch,
    TpPaymentMethodType.BankSepa,
    TpPaymentMethodType.BankFedwire,
  ];
  return !!pm?.type && bankTypes.includes(pm.type);
}

export function isIdentifierPixMethod(
  pm: TpPaymentMethodUI | undefined,
): pm is TpPaymentMethodIdentifierPixUI {
  return pm?.type === TpPaymentMethodType.IdentifierPix;
}
